import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderV2Component } from './header-v2.component';
import { AlertModule } from '../alert/alert.module';
import { NotificationModule } from '../notification/notification.module';

@NgModule({
  imports: [
    CommonModule,
    AlertModule,
    NotificationModule
  ],
  declarations: [HeaderV2Component],
  exports: [
    HeaderV2Component
  ],
  providers: []
})
export class HeaderV2Module { }
